import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import companySignin from "./services";
import { jwtDecode } from "jwt-decode";
import StatusNavigator from "../../navigator";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ForgetApi from "./services";
import SupervisorServices from "./services";

import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";

const SupervisorForgotPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [validatedOtp, setValidatedOtp] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("error");
  const [optRecevied, setOptRecevied] = useState(false);
  const [optLoad, setOptLoad] = useState(false);
  const [company, setCompany] = useState([]);
  const [email, setEmail] = useState("");
  const [load, setLoad] = useState(false);
  const path = location.state.path;
  console.log(path);
  const dataJson = {
    newPassword: "",
    confirmPassword: "",
    otpValue: "",
  };

  const token = localStorage.getItem("token");
  const jwt = token ? jwtDecode(token) : null;
  const role = jwt?.role[0]?.name;

  const [data, setData] = useState(dataJson);

  const setValue = (e) => {
    const { name, value } = e.target;
    const phoneRegex = /^[0-9\b]+$/;
    if (name == "otpValue") {
      if (value == "" || phoneRegex.test(value) == true) {
        setData({ ...data, [name]: value });
      }
    } else {
      setData({ ...data, [name]: value });
    }
  };
  const formatDate1 = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yy = String(date.getFullYear()).slice(-2);

    return `${dd}-${mm}-${yy}`;
  };

  const forgetpassword = () => {
    debugger;
    setOptLoad(true);
    ForgetApi.getTop({ email: email, companyId: company[0].companyId })
      .then((respons) => {
        console.log(respons);
        setOptLoad(false);
        setOptRecevied(respons.data.status == true);
        if (respons.data.status == true) {
          setMessage(respons.data.message);
          setSeverity("success");
          setOpen(true);
        }
      })
      .catch((e) => {
        if (e.response.status) {
          setOptLoad(false);
          setOpen(true);
          setMessage(e.response.data.message);
          setSeverity("error");
        }
      });
  };

  // const resetPassword = () => {
  //   debugger;
  //   setOptLoad(true);
  //   ForgetApi.resetPassword({
  //     ...data,
  //     email: email,
  //     companyId: company[0].companyId,
  //   })
  //     .then((respons) => {
  //       console.log(respons);
  //       setOptLoad(false);
  //       setOptRecevied(respons.data.status == true);
  //       if (respons.data.status == true) {
  //         console.log(respons.data.message);
  //         navigate(path, {
  //           state: { resetPassword: true, message: respons.data.message },
  //         });
  //         setMessage(respons.data.message);
  //         setSeverity("success");
  //         setOpen(true);
  //       }
  //     })
  //     .catch((e) => {
  //       setOptLoad(false);
  //       if (e.response.status == 404) {
  //         setOpen(true);
  //         setMessage(e.response.data.message);
  //         setSeverity("error");
  //       }
  //     });
  // };

  const resetPassword = async () => {
    setOptLoad(true); // Start loader
    // Reset any previous error states
    setErrors({
      email: "",
      companyId: "",
    });

    try {
      // Make API call to reset password
      const response = await ForgetApi.resetPassword({
        ...data,
        email: email,
        companyId: company[0].companyId,
      });

      // Handle successful response
      if (response.status === 200 && response.data.status === true) {
        console.log(response.data.message);
        setOptRecevied(true); // Mark that the response is received
        setMessage(response.data.message); // Show success message
        setSeverity("success");
        setOpen(true); // Open toast with success message

        navigate(path, {
          state: { resetPassword: true, message: response.data.message },
        });
      }
      setOptLoad(false); // Stop loader after success
    } catch (errorState) {
      // Handle error response from the server
      setOptLoad(false); // Stop loader on error

      if (errorState.response && errorState.response.status === 400) {
        const errorData = errorState.response.data;
        console.log("errorState", errorData);

        if (errorData.errorState) {
          const fieldErrors = errorData.errorState;

          // Check if setNewPasswordReq error exists and display it in the toast
          if (
            fieldErrors.resetPasswordRequest &&
            fieldErrors.resetPasswordRequest.length > 0
          ) {
            // Display the first error message from the setNewPasswordReq array in the toast
            setOpen(true);
            setMessage(fieldErrors.resetPasswordRequest[0]);
            setSeverity("error");
          } else {
            // Handle specific field errors if present
            setErrors({
              email: fieldErrors.email ? fieldErrors.email : "",
              companyId: fieldErrors.companyId ? fieldErrors.companyId : "",
            });
          }
        } else if (errorData.message) {
          // Show general error message in the toast
          setOpen(true);
          setMessage(errorData.message);
          setSeverity("error");
        }
      } else if (errorState.response && errorState.response.status === 404) {
        // Handle 404 errors specifically
        setOpen(true);
        setMessage(errorState.response.data.message);
        setSeverity("error");
      }
    }
  };

  ///------------------get company list--------------
  const getCompany = () => {
    debugger;
    console.log("email_12345", email);
    if (!email) {
      setCompany([]);
      setLoad(false);
      return;
    }
    SupervisorServices.getCompanyList(email)
      .then((response) => {
        debugger;
        console.log("response:", response);
        const companies = response.data.data;
        console.log("companies:", companies);
        setCompany(companies);
        setLoad(false);
      })
      .catch((error) => {
        console.error("Error fetching company list:", error);
        setMessage("Error fetching company list:", error.message);
        setSeverity("error");
        setOpen(true);
        setCompany([]);
        setLoad(false);
      });
    //----end company funtion
  };
  const resetPasswordSubmit = (event) => {
    debugger;
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (
        data.otpValue !== "" &&
        data.newPassword !== "" &&
        data.confirmPassword !== ""
      ) {
        resetPassword();
      }
    }
    setValidatedOtp(true);
  };

  const [errors, setErrors] = useState({
    email: "",
    companyId: "",
  });

  // const handleCompanyChange = (selectedCompanyId) => {
  //   setValue("companyId", selectedCompanyId);
  // };
  const handleSubmit = (event) => {
    debugger;
    setValidated(false);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      debugger;
      if (email !== "") {
        forgetpassword();
      }
    }
    setValidated(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/dashboard/supervisor/home");
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <StatusNavigator />
      <div className="wrapper">
        <main className="authentication-content">
          <div className="container">
            <div className="authentication-card">
              <div className="card shadow rounded-0 overflow-hidden w-100 mt-3">
                <div className="row g-0">
                  <div className="col-lg-6 bg-login align-items-center justify-content-center">
                    <div className="px-4 px-lg-5 text-center">
                      <img
                        className="me-2 mb-3 mt-lg-5 pt-lg-5"
                        src="/assets/images/login-img.png"
                        alt="login-img"
                      />
                      <p className="mt-lg-3 mb-4">
                        Your all-in-one solution designed to streamline
                        registration processes, enhance workflow visibility, and
                        drive productivity across a wide range of industries
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card-body p-4 p-sm-5">
                      <div className="text-center">
                        <img
                          className="me-2 mb-3"
                          src="/assets/images/tapme-icon.svg"
                          width="66"
                          alt=""
                        />
                        <h3 className="card-title mb-3">
                          {optRecevied ? "Reset" : "Forgot"} Password
                        </h3>
                      </div>
                      {optRecevied ? null : (
                        <>
                          <Form
                            className="form-body pt-2"
                            noValidate
                            validated={validated}
                          >
                            <div className="row g-3">
                              <div className="col-12">
                                <Form.Group
                                  controlId="validationCustom01"
                                  className="ms-auto position-relative"
                                >
                                  {/* Search Icon */}
                                  <div className="position-absolute translate-middle-y2 search-icon1 px-6">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="17"
                                      viewBox="0 0 20 17"
                                      fill="none"
                                      style={{
                                        transform: "translate(47%, 8%)",
                                      }}
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M7.96912 2.94814e-07H11.7392C13.4238 -1.42388e-05 14.7582 -2.58163e-05 15.8024 0.140374C16.8772 0.284866 17.747 0.589307 18.433 1.27531C19.119 1.96131 19.4235 2.83118 19.568 3.9059C19.7084 4.95018 19.7083 6.28451 19.7083 7.96912V8.07254C19.7083 9.75716 19.7084 11.0915 19.568 12.1358C19.4235 13.2105 19.119 14.0804 18.433 14.7664C17.747 15.4524 16.8772 15.7568 15.8024 15.9013C14.7582 16.0417 13.4238 16.0417 11.7392 16.0417H7.96912C6.28451 16.0417 4.95018 16.0417 3.9059 15.9013C2.83118 15.7568 1.96131 15.4524 1.27531 14.7664C0.589307 14.0804 0.284866 13.2105 0.140374 12.1358C-2.58163e-05 11.0915 -1.42388e-05 9.75716 2.94814e-07 8.07255V7.96912C-1.42388e-05 6.2845 -2.58163e-05 4.95018 0.140374 3.9059C0.284866 2.83118 0.589307 1.96131 1.27531 1.27531C1.96131 0.589307 2.83118 0.284866 3.9059 0.140374C4.95018 -2.58163e-05 6.28451 -1.42388e-05 7.96912 2.94814e-07ZM4.08911 1.50311C3.16686 1.62711 2.63552 1.85964 2.24758 2.24758C1.85964 2.63552 1.62711 3.16686 1.50311 4.08911C1.37646 5.03114 1.375 6.27292 1.375 8.02083C1.375 9.76875 1.37646 11.0105 1.50311 11.9526C1.62711 12.8748 1.85964 13.4061 2.24758 13.7941C2.63552 14.182 3.16686 14.4146 4.08911 14.5386C5.03114 14.6652 6.27291 14.6667 8.02083 14.6667H11.6875C13.4354 14.6667 14.6772 14.6652 15.6192 14.5386C16.5415 14.4146 17.0728 14.182 17.4608 13.7941C17.8487 13.4061 18.0812 12.8748 18.2052 11.9526C18.3319 11.0105 18.3333 9.76875 18.3333 8.02083C18.3333 6.27292 18.3319 5.03114 18.2052 4.08911C18.0812 3.16686 17.8487 2.63552 17.4608 2.24758C17.0728 1.85964 16.5415 1.62711 15.6192 1.50311C14.6772 1.37646 13.4354 1.375 11.6875 1.375H8.02083C6.27292 1.375 5.03114 1.37646 4.08911 1.50311ZM3.82602 3.91404C4.06909 3.62235 4.5026 3.58294 4.79429 3.82601L6.77328 5.47517C7.62849 6.18785 8.22225 6.68105 8.72353 7.00345C9.20878 7.31554 9.53785 7.4203 9.85417 7.4203C10.1705 7.4203 10.4996 7.31554 10.9848 7.00345C11.4861 6.68105 12.0798 6.18785 12.9351 5.47517L14.914 3.82601C15.2057 3.58294 15.6392 3.62235 15.8823 3.91404C16.1254 4.20573 16.086 4.63924 15.7943 4.88232L13.7808 6.56019C12.9684 7.23729 12.3098 7.7861 11.7286 8.15991C11.1231 8.54932 10.5335 8.7953 9.85417 8.7953C9.17485 8.7953 8.5852 8.54932 7.97975 8.15991C7.39853 7.7861 6.73999 7.2373 5.9275 6.5602L3.91404 4.88232C3.62235 4.63924 3.58294 4.20573 3.82602 3.91404Z"
                                        fill="#1E73FF"
                                      />
                                    </svg>
                                  </div>

                                  <Form.Control
                                    className="form-control radius-4 ps-5 height-50"
                                    required
                                    type="email"
                                    placeholder="Email Address"
                                    name="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                  <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="position-relative">
                                  {/* Dropdown Icon */}

                                  <div className="position-absolute translate-middle-y2 search-icon1 px-6">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="25"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      style={{
                                        transform: "translate(47%, 8%)",
                                      }}
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M14.948 1.25H17.052C17.9505 1.24997 18.6997 1.24995 19.2945 1.32991C19.9223 1.41432 20.4891 1.59999 20.9445 2.05546C21.4 2.51093 21.5857 3.07773 21.6701 3.70552C21.7501 4.30031 21.75 5.04953 21.75 5.94801V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H2.25L2.25 8.948C2.24997 8.04952 2.24994 7.3003 2.32991 6.70552C2.41432 6.07773 2.59999 5.51093 3.05546 5.05546C3.51093 4.59999 4.07773 4.41432 4.70552 4.32991C5.3003 4.24995 6.04952 4.24997 6.948 4.25L10.278 4.25C10.3294 3.37583 10.4906 2.62032 11.0555 2.05546C11.5109 1.59999 12.0777 1.41432 12.7055 1.32991C13.3003 1.24995 14.0495 1.24997 14.948 1.25ZM11.0068 5.75C11.0055 5.75 11.0043 5.75 11.003 5.75C11.002 5.75 11.001 5.75 11 5.75H7C6.03599 5.75 5.38843 5.7516 4.90539 5.81654C4.44393 5.87858 4.24643 5.9858 4.11612 6.11612C3.9858 6.24644 3.87858 6.44393 3.81654 6.90539C3.75159 7.38843 3.75 8.03599 3.75 9V21.25H8.25V19C8.25 18.5858 8.58579 18.25 9 18.25C9.41421 18.25 9.75 18.5858 9.75 19V21.25H14.25V9C14.25 8.03599 14.2484 7.38843 14.1835 6.90539C14.1214 6.44393 14.0142 6.24644 13.8839 6.11612C13.7536 5.9858 13.5561 5.87858 13.0946 5.81654C12.6127 5.75175 11.9671 5.75001 11.0068 5.75ZM15.75 21.25L15.75 8.94801C15.75 8.04953 15.7501 7.30031 15.6701 6.70552C15.5857 6.07773 15.4 5.51093 14.9445 5.05546C14.4891 4.59999 13.9223 4.41432 13.2945 4.32991C12.8691 4.27273 12.3648 4.25645 11.7834 4.25183C11.8335 3.55219 11.9436 3.28863 12.1161 3.11612C12.2464 2.9858 12.4439 2.87858 12.9054 2.81654C13.3884 2.7516 14.036 2.75 15 2.75H17C17.964 2.75 18.6116 2.7516 19.0946 2.81654C19.5561 2.87858 19.7536 2.9858 19.8839 3.11612C20.0142 3.24644 20.1214 3.44393 20.1835 3.90539C20.2484 4.38843 20.25 5.03599 20.25 6V21.25H15.75ZM5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H12C12.4142 7.25 12.75 7.58579 12.75 8C12.75 8.41422 12.4142 8.75 12 8.75H6C5.58579 8.75 5.25 8.41422 5.25 8ZM5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11ZM5.25 14C5.25 13.5858 5.58579 13.25 6 13.25H12C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75H6C5.58579 14.75 5.25 14.4142 5.25 14Z"
                                        fill="#1E73FF"
                                      />
                                    </svg>
                                  </div>
                                  <Form.Select
                                    className={`form-control radius-4 ps-5 height-50 ${
                                      errors.companyId ? "is-invalid" : ""
                                    }`}
                                    aria-label="Default select example"
                                    name="companyId"
                                    required
                                    value={data.companyId}
                                    onClick={() => getCompany()}
                                    style={{
                                      marginTop: "15px",
                                    }}
                                  >
                                    <option value="" disable d>
                                      Select Company
                                    </option>
                                    {Array.isArray(company) &&
                                      company.map((companyOption) => (
                                        <option
                                          key={companyOption.companyId}
                                          value={companyOption.companyId}
                                        >
                                          {companyOption.companyName}
                                        </option>
                                      ))}
                                  </Form.Select>
                                  <Form.Control.Feedback
                                    type="invalid"
                                    style={{ position: "absolute" }}
                                  >
                                    {errors.companyId}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                            </div>
                          </Form>
                          <div className="col-12 mt-3">
                            <div className="d-grid">
                              {optLoad ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <CircularProgress />
                                </div>
                              ) : (
                                <button
                                  to="/dashboard/admin/home"
                                  type="submit"
                                  className="btn btn-primary login-btn height-50"
                                  onClick={handleSubmit}
                                >
                                  Send OTP
                                </button>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {optRecevied ? (
                        <>
                          <Form
                            className="form-body pt-2"
                            noValidate
                            validated={validatedOtp}
                          >
                            <div className="col-12 mt-3">
                              <Form.Group
                                controlId="validationCustom02"
                                className="ms-auto position-relative"
                              >
                                {/* Search Icon */}
                                <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M6 22C5.45 22 4.979 21.804 4.587 21.412C4.195 21.02 3.99934 20.5493 4 20V10C4 9.45 4.196 8.979 4.588 8.587C4.98 8.195 5.45067 7.99933 6 8H7V6C7 4.61667 7.48767 3.43733 8.463 2.462C9.43834 1.48667 10.6173 0.999334 12 1C13.3833 1 14.5627 1.48767 15.538 2.463C16.5133 3.43833 17.0007 4.61733 17 6V8H18C18.55 8 19.021 8.196 19.413 8.588C19.805 8.98 20.0007 9.45067 20 10V20C20 20.55 19.804 21.021 19.412 21.413C19.02 21.805 18.5493 22.0007 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.021 16.804 13.413 16.412C13.805 16.02 14.0007 15.5493 14 15C14 14.45 13.804 13.979 13.412 13.587C13.02 13.195 12.5493 12.9993 12 13C11.45 13 10.979 13.196 10.587 13.588C10.195 13.98 9.99934 14.4507 10 15C10 15.55 10.196 16.021 10.588 16.413C10.98 16.805 11.4507 17.0007 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
                                      fill="#1E73FF"
                                    />
                                  </svg>
                                </div>
                                <Form.Control
                                  className="form-control radius-4 ps-5 height-50"
                                  required
                                  type="text"
                                  placeholder="Enter OTP"
                                  name="otpValue"
                                  minLength={6}
                                  maxLength={6}
                                  value={data.otpValue}
                                  onChange={setValue}
                                />
                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                              </Form.Group>
                              <button
                                onClick={() => {
                                  setOptRecevied(false);
                                  setValidated(false);
                                }}
                                style={{
                                  background: "none",
                                  border: "none",
                                  display: "block",
                                  marginLeft: "auto",
                                }}
                              >
                                Resend OTP
                              </button>

                              <div className="col-12 mt-3">
                                <Form.Group
                                  controlId="validationCustom03"
                                  className="ms-auto position-relative"
                                >
                                  <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M6 22C5.45 22 4.979 21.804 4.587 21.412C4.195 21.02 3.99934 20.5493 4 20V10C4 9.45 4.196 8.979 4.588 8.587C4.98 8.195 5.45067 7.99933 6 8H7V6C7 4.61667 7.48767 3.43733 8.463 2.462C9.43834 1.48667 10.6173 0.999334 12 1C13.3833 1 14.5627 1.48767 15.538 2.463C16.5133 3.43833 17.0007 4.61733 17 6V8H18C18.55 8 19.021 8.196 19.413 8.588C19.805 8.98 20.0007 9.45067 20 10V20C20 20.55 19.804 21.021 19.412 21.413C19.02 21.805 18.5493 22.0007 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.021 16.804 13.413 16.412C13.805 16.02 14.0007 15.5493 14 15C14 14.45 13.804 13.979 13.412 13.587C13.02 13.195 12.5493 12.9993 12 13C11.45 13 10.979 13.196 10.587 13.588C10.195 13.98 9.99934 14.4507 10 15C10 15.55 10.196 16.021 10.588 16.413C10.98 16.805 11.4507 17.0007 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
                                        fill="#1E73FF"
                                      />
                                    </svg>
                                  </div>
                                  <Form.Control
                                    className="form-control radius-4 ps-5 height-50"
                                    required
                                    type="password"
                                    placeholder="Enter New password"
                                    name="newPassword"
                                    maxLength={15}
                                    minLength={8}
                                    pattern="^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$"
                                    onChange={setValue}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Ex. (Password@123)
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-12 mt-3">
                                <Form.Group
                                  controlId="validationCustom04"
                                  className="ms-auto position-relative"
                                >
                                  <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M6 22C5.45 22 4.979 21.804 4.587 21.412C4.195 21.02 3.99934 20.5493 4 20V10C4 9.45 4.196 8.979 4.588 8.587C4.98 8.195 5.45067 7.99933 6 8H7V6C7 4.61667 7.48767 3.43733 8.463 2.462C9.43834 1.48667 10.6173 0.999334 12 1C13.3833 1 14.5627 1.48767 15.538 2.463C16.5133 3.43833 17.0007 4.61733 17 6V8H18C18.55 8 19.021 8.196 19.413 8.588C19.805 8.98 20.0007 9.45067 20 10V20C20 20.55 19.804 21.021 19.412 21.413C19.02 21.805 18.5493 22.0007 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.021 16.804 13.413 16.412C13.805 16.02 14.0007 15.5493 14 15C14 14.45 13.804 13.979 13.412 13.587C13.02 13.195 12.5493 12.9993 12 13C11.45 13 10.979 13.196 10.587 13.588C10.195 13.98 9.99934 14.4507 10 15C10 15.55 10.196 16.021 10.588 16.413C10.98 16.805 11.4507 17.0007 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
                                        fill="#1E73FF"
                                      />
                                    </svg>
                                  </div>
                                  <Form.Control
                                    className="form-control radius-4 ps-5 height-50"
                                    required
                                    type="password"
                                    placeholder="Enter Confirm password"
                                    name="confirmPassword"
                                    maxLength={15}
                                    minLength={8}
                                    pattern="^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$"
                                    onChange={setValue}
                                  />
                                  <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <button
                                onClick={() => {
                                  setOptRecevied(false);
                                  // setEmail("");
                                }}
                                type="button"
                                className="btn btn-sm btn-outline-danger position-absolute"
                                style={{
                                  right: "0",
                                  top: "-40px",
                                  zIndex: "999",
                                }}
                              >
                                X
                              </button>
                            </div>
                            <div className="col-12 mt-3">
                              <div className="d-grid">
                                {optLoad ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <CircularProgress />
                                  </div>
                                ) : (
                                  <button
                                    to="/dashboard/supervisor/home"
                                    type="button"
                                    className="btn btn-primary login-btn height-50"
                                    onClick={resetPasswordSubmit}
                                  >
                                    Submit
                                  </button>
                                )}
                              </div>
                            </div>
                          </Form>
                        </>
                      ) : null}
                      {optRecevied ? null : (
                        <div className="text-center mt-4">
                          <Link
                            to="/"
                            className="text-muted font-size-15"
                            onClick={() => setOptRecevied(true)}
                          >
                            Back to Login
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};

export default SupervisorForgotPassword;
